(function(){
    const $links = document.querySelectorAll('.article__body a[title="product-feed"]');
    // article__body a[title="Faverige Plakater"],
    
    function addStyles() {
        let styles = `
          .grid-product__link {
            width: 100%;
            border-bottom: 0 !important;
          }
          .grid-product__link:after {
            display: none !important;
          }

          .article__body a[title="product-feed"] { display: none !important; }

          .article-grid[data-type="products"] .article-grid__items {
            display: flex;
            justify-content: center;
          }

          @media (max-width: 768px) {
            .grid-overflow-wrapper .grid__item:first-child {
                margin-left: 0;
            }

            .grid-overflow-wrapper {
                padding-bottom: 30px;
            }
          }
        `;
        
        var $style = document.createElement('style');

        $style.textContent = styles;

        document.head.appendChild($style);
    }

    function removeProtocol(href) {
        return href.replace(/http(s)?:/, '').replace(/^\/\//, '');
    }

    function linkTypeDetector(href) {
        href = removeProtocol(href);
        var parts = href.match(/\/(products|collections)\//ig);

        return parts.length ? parts.reverse()[0].replace(/\//ig, '') : null;
    }

    function addUrlParameters(url, parameters) {
        url = new URL(url);

        console.log('Create Url!', url, url.href);
        // const url = window.Shopify.locale == 'da' ? `/products/${this.productHandle}.js` : `/${window.Shopify.locale}/products/${this.productHandle}.js`


        for(param in parameters) {
            url.searchParams.set(param, parameters[param]);
        }

        return url;
    }

    function fetchCollectionMarkup(href) {
        let url = addUrlParameters(href, {
            view: 'ajax',
        });

        return fetch(url.href).then((res) => res.text());
    }

    function fetchProductMarkup(href) {
        let url = addUrlParameters(href, {
            view: 'item-html',
        });

        return fetch(url.href).then((res) => res.text());
    }

    function htmlToEl(markup) {
        var parser = new DOMParser();
        return parser.parseFromString(markup, 'text/html');
    }

    function renderContainer($items) {
        var $container = document.createElement('div');
        $container.classList.add('article-grid');
        $container.classList.add('grid-overflow-wrapper');

        $container.innerHTML = `
          <div class="article-grid__items grid"></div>
        `;

        $items.forEach(function($item) {
            $item.classList.remove('small--one-half');
            $item.classList.remove('medium-up--one-quarter');  

            if($items.length < 4) {
                $item.classList.add('small--one-half');
                $item.classList.add('medium-up--one-third');                
            }

            $container.querySelector('.article-grid__items').appendChild($item);
        });

        return $container;
    }
    


    async function createDynamicFeed($link) {
        var $p = $link.closest('p');
        var linkType = linkTypeDetector($link.href); 


        console.log('Trying link', $link);

        var markup = linkType === 'products' ? await fetchProductMarkup($link.href) : await fetchCollectionMarkup($link.href); 
        var $doc = htmlToEl(markup);
        var selector = linkType === 'products' ? '.grid-product' : '.boost-pfs-filter-products .grid-product';
        var $items = $doc.querySelectorAll(selector);
        var $container = renderContainer($items);

        console.log('Link had elemnts', {
            href: $link.href,
            $items,
            $doc,
            markup,
        });

        $container.setAttribute('data-type', linkType);

        $p.parentNode.replaceChild($container, $p);
        if ($items.length > 4) {
            $($container.querySelector('.article-grid__items')).slick({
                slidesToShow: 3,
                arrows: true,
                slidesToScroll: 3,
                prevArrow: renderSlickArrows.prev(),
                nextArrow: renderSlickArrows.next(),
                responsive: [
                  {
                    breakpoint: 768,
                    settings: 'unslick',
                  }
                ]
            })
        }
        $container.querySelector('.article-grid__items').classList.add('aos-init')
        $container.querySelector('.article-grid__items').classList.add('aos-animate');

        console.log('Link Type:', {linkType, href: $link.href, markup, $items});
    }

    addStyles();

    console.log('Article links:', $links);

    $links.forEach(createDynamicFeed);

})();